"use client";

import React, { useState } from 'react';
import { ArrowRight, ShieldCheck, FileText, Network } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ContractGraph = () => {
  const [hoveredNode, setHoveredNode] = useState<string | null>(null);
  const nodes = [{
    id: "Contratto",
    x: 400,
    y: 200,
    group: 1,
    radius: 12
  }, {
    id: "Parti",
    x: 280,
    y: 150,
    group: 2,
    radius: 8
  }, {
    id: "Oggetto",
    x: 280,
    y: 250,
    group: 2,
    radius: 8
  }, {
    id: "Corrispettivo",
    x: 520,
    y: 150,
    group: 2,
    radius: 8
  }, {
    id: "Durata",
    x: 520,
    y: 250,
    group: 2,
    radius: 8
  }, {
    id: "Recesso",
    x: 180,
    y: 100,
    group: 3,
    radius: 6
  }, {
    id: "Riservatezza",
    x: 350,
    y: 80,
    group: 3,
    radius: 6
  }, {
    id: "Penali",
    x: 620,
    y: 100,
    group: 3,
    radius: 6
  }, {
    id: "Foro",
    x: 450,
    y: 80,
    group: 3,
    radius: 6
  }, {
    id: "Legge",
    x: 550,
    y: 80,
    group: 3,
    radius: 6
  }, {
    id: "Allegato A",
    x: 200,
    y: 320,
    group: 4,
    radius: 4
  }, {
    id: "Allegato B",
    x: 360,
    y: 320,
    group: 4,
    radius: 4
  }];
  const links = [{
    source: "Contratto",
    target: "Parti"
  }, {
    source: "Contratto",
    target: "Oggetto"
  }, {
    source: "Contratto",
    target: "Corrispettivo"
  }, {
    source: "Contratto",
    target: "Durata"
  }, {
    source: "Parti",
    target: "Recesso"
  }, {
    source: "Oggetto",
    target: "Allegato A"
  }, {
    source: "Oggetto",
    target: "Allegato B"
  }, {
    source: "Corrispettivo",
    target: "Penali"
  }, {
    source: "Durata",
    target: "Recesso"
  }, {
    source: "Contratto",
    target: "Riservatezza"
  }, {
    source: "Contratto",
    target: "Foro"
  }, {
    source: "Contratto",
    target: "Legge"
  }];
  const getNodeById = (id: string) => nodes.find(n => n.id === id);
  const getNodeColor = (group: number) => {
    if (group === 1) return "var(--primary)";
    if (group === 2) return "var(--accent)";
    return "var(--muted-foreground)";
  };
  return <div className="w-full h-[400px] relative overflow-hidden">
      <svg viewBox="0 0 800 400" className="w-full h-full block">
        {}
        <g stroke="var(--border)" strokeOpacity="0.4">
          {links.map((link, i) => {
          const source = getNodeById(link.source);
          const target = getNodeById(link.target);
          if (!source || !target) return null;
          return <line key={i} x1={source.x} y1={source.y} x2={target.x} y2={target.y} strokeWidth="1.5" className="transition-all duration-300" style={{
            strokeOpacity: hoveredNode && (hoveredNode === link.source || hoveredNode === link.target) ? 0.8 : 0.4
          }} />;
        })}
        </g>

        {}
        <g>
          {nodes.map(node => <g key={node.id}>
              <circle cx={node.x} cy={node.y} r={node.radius} fill={getNodeColor(node.group)} stroke="var(--background)" strokeWidth="1.5" className="transition-all duration-300 cursor-pointer" style={{
            transform: hoveredNode === node.id ? 'scale(1.2)' : 'scale(1)',
            transformOrigin: `${node.x}px ${node.y}px`
          }} onMouseEnter={() => setHoveredNode(node.id)} onMouseLeave={() => setHoveredNode(null)} />
              {node.radius > 5 && <text x={node.x + 15} y={node.y + 4} fontSize="10" fill="var(--foreground)" fontFamily="var(--font-sans)" style={{
            pointerEvents: 'none',
            opacity: 0.8
          }}>
                  {node.id}
                </text>}
            </g>)}
        </g>
      </svg>
      {}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-t from-card/10 to-transparent"></div>
    </div>;
};
export default function ArchitetturaContrattuale() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return;
}